var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var VideoAsset = /** @class */ (function () {
    function VideoAsset(video) {
        var _this = this;
        this.addTypeAndKeyToObject = function (object, _type) { return (__assign({ _type: _type, _key: Math.random().toString(16).substring(3) }, object)); };
        this.generateDownloadObject = function (downloadQualities) {
            return downloadQualities.map(function (quality) { return (_this.addTypeAndKeyToObject(quality, 'vimeo.video.downloadQuality')); });
        };
        this.generatePicturesObject = function (pictures) {
            return __assign(__assign({}, pictures), { _type: 'vimeo.video.pictures', sizes: pictures.sizes.map(function (size) { return (_this.addTypeAndKeyToObject(size, 'vimeo.picture.size')); }) });
        };
        this.generatePrivacyObject = function (privacy) {
            return __assign(__assign({}, privacy), { _type: 'vimeo.video.privacy' });
        };
        this.generateAsset = function (video) {
            var base = __assign(__assign({}, video), { _createdAt: video.created_time, _updatedAt: video.modified_time, _id: video.resource_key, _type: 'vimeo.videoAsset', _rev: '' });
            base.files = _this.generateDownloadObject(base.files);
            base.pictures = _this.generatePicturesObject(base.pictures);
            base.privacy = _this.generatePrivacyObject(base.privacy);
            return base;
        };
        this.videoAsset = this.generateAsset(video);
    }
    return VideoAsset;
}());
export default VideoAsset;
